import { render, staticRenderFns } from "./VehicleSubMenu.vue?vue&type=template&id=3511b6ba&"
import script from "./VehicleSubMenu.vue?vue&type=script&lang=js&"
export * from "./VehicleSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports